import datalightCustom from "./datalight-custom.json";
import datadarkCustom from "./datadark-custom.json";

export const STYLES = {
    datalight: datalightCustom,
    datadark: datadarkCustom
}